export default __webpack_public_path__ + "static/backgroundHome--blurV-4f6c6cb742e60ca2387275730146cdec.jpg";